import { BareActionContext } from 'vuex-typex'
import { ConvoState } from '../state'
import { RootState } from '../..'
import convoUtils from './convo-utils'
import { IConvo, Convo } from '../../../model/convo'
import convoStore from '../convo-store'
import setMeta from './set-meta'
import fetchConvos from './fetch-convos'
import { IReference, Reference } from '@/model/reference';
import feedStore from '@/store/feed/feed-store';

export default async function addConvo(context: BareActionContext<ConvoState, RootState>)
{
    let form = convoStore.state.convoForm
    let convo: IConvo = new Convo()
    convo.title = convoStore.state.convoForm.title
    convo.body = convoStore.state.convoForm.body
    
    if(form.referenceUrl || form.referenceDesc) {
        let reference: IReference = new Reference()
        reference.url = form.referenceUrl
        reference.description = form.referenceDesc
        form.references.push(reference)
    }
    if(
        form.tag && 
        form.tags.indexOf(form.tag) < 0
    ) {
        form.tags.push(form.tag)
    }

    convoUtils.convoService.addConvo(convo, form.tags, form.references, form.statements).then((result: any) => {
        convoStore.commitResetConvoForm({ })
        feedStore.dispatchViewConvos()
    })

    return
}
